'use client';

import { useEffect } from 'react';
import { initializePerformanceMonitoring } from '@/lib/performance-monitoring';

/**
 * Performance Monitor Component
 * 
 * Initializes Web Vitals monitoring on the client side.
 * This component should be included once in the root layout.
 */
export function PerformanceMonitor() {
  useEffect(() => {
    // Initialize performance monitoring when component mounts
    initializePerformanceMonitoring();
  }, []);

  // This component doesn't render anything
  return null;
}
